import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import "./FindShelf.css";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

function Findshelf() {
  const [data, setData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        setData(response.data);
      }
    );
  }, []);

  const handleSearchClick = async () => {
    let keyToSearch = inputValue.trim();
    try {
      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getKey/${inputValue}`
      );
      if (response.data.key) {
        keyToSearch = response.data.key.trim();
      }
    } catch (error) {
      console.error("Error fetching key:", error);
    }

    const filteredData = data.filter((item) =>
      item.barcodeData.includes(keyToSearch)
    );

    setSearchResults(filteredData);
    setShowSearchResults(true);
    setSearchQuery(inputValue);
  };

  useEffect(() => {
    setShowSearchResults(false);
  }, [inputValue]);

  return (
    <div className="findshelf-container">
      <h6 className="FindShelfHead">
        <h3>Book Shelf Status</h3>
      </h6>
      <br />

      <input
        className="findsearch"
        type="text"
        placeholder="Search Barcode"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <Button className="findshelfbtn" onClick={handleSearchClick}>
        Search
      </Button>

      <br />
      <br />
      <div>
        {showSearchResults ? (
          <Table
            striped
            bordered
            hover
            responsive
            style={{
              border: "1px solid black",
              width: "100%",
              textAlign: "center",
            }}
          >
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>Warehouse</th>
                <th style={{ border: "1px solid black" }}>Shelf No</th>
                <th style={{ border: "1px solid black" }}>Title</th>
                <th style={{ border: "1px solid black" }}>Medium</th>
              </tr>
            </thead>

            <tbody>
              {searchResults.map((row, key) => (
                <tr key={key}>
                  <td style={{ border: "1px solid black" }}>{row.Warehouse}</td>
                  <td style={{ border: "1px solid black" }}>{row.shelfno}</td>
                  <td style={{ border: "1px solid black" }}>{row.title}</td>
                  <td style={{ border: "1px solid black" }}>{row.Medium}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : null}
      </div>
    </div>
  );
}

export default Findshelf;
